import {
  AppData,
  Container,
  UnifiedLightbox,
} from '../../../../../types/unifiedComponents';
import { CompRef, PageProperties } from '@wix/document-services-types';
import { StyleRef } from '@wix/document-services-types/src/data';
import { TOKEN } from './addUnifiedComponents';
import { PopupPageStructure } from '@wix/editor-platform-host-integration-apis';
import { ExtendedPlatformContext } from '../../../../../types/platformApi';

const ref = {
  fittingType: 'fill',
  alignType: 'center',
  color: '#000000',
  colorOpacity: 0.6,
  type: 'BackgroundMedia',
  scrollType: 'none',
};

export const style = {
  componentClassName: 'mobile.core.components.Page',
  skin: 'wysiwyg.viewer.skins.page.TransparentPageSkin',
  type: 'ComponentStyle' as StyleRef['type'],
  style: {
    groups: {},
    properties: { 'alpha-bg': '0.6', bg: '#000000' },
    propertiesSource: { 'alpha-bg': 'value', bg: 'value' },
  },
  styleType: 'custom',
};

export const pageBackgrounds = {
  desktop: {
    ref,
    custom: true,
    isPreset: true,
  },
  mobile: {
    ref,
    custom: true,
    isPreset: true,
    mediaSizing: 'viewport',
  },
};

const createDefinition = (
  lightboxDefinition: UnifiedLightbox,
  appData: AppData,
): PopupPageStructure => {
  const popup = {
    popup: {
      closeOnOverlayClick:
        lightboxDefinition.closeOptions?.closeOnOverlayClick ?? true,
    },
  };

  const props: PageProperties = {
    type: 'PageProperties',
    desktop: popup,
    mobile: popup,
  };

  return {
    style: {
      componentClassName: 'mobile.core.components.Page',
      skin: 'wysiwyg.viewer.skins.page.TransparentPageSkin',
      type: 'ComponentStyle' as StyleRef['type'],
      style: {
        groups: {},
        properties: { 'alpha-bg': '0.6', bg: '#000000' },
        propertiesSource: { 'alpha-bg': 'value', bg: 'value' },
      },
      styleType: 'custom',
    },
    data: {
      pageBackgrounds,
      tpaPageId: lightboxDefinition.base?.id,
      appDefinitionId: appData.appDefinitionId,
      managingAppDefId: appData.appDefinitionId,
      indexable: false,
      isPopup: true,
    },
    props,
  };
};

export async function createBlankLightbox(
  container: Container,
  context: ExtendedPlatformContext,
  appData: AppData,
) {
  const lightboxDefinition = container.data as UnifiedLightbox;
  return new Promise<CompRef>(async (resolve, reject) => {
    const definition = createDefinition(lightboxDefinition, appData);
    try {
      const compRef =
        await context.platformApiMethods.document.pages.popupPages.add(
          appData,
          TOKEN,
          {
            title: lightboxDefinition.base?.name as string,
            definition,
          },
        );

      context.documentServices.waitForChangesApplied(() => resolve(compRef));
    } catch (error) {
      reject(error);
    }
  });
}
